export default {
  hrNotifications: [],
};
